import { useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
//primereact
import { Button } from "primereact/button";
//components
import Modal from "../../../../components/modal/Modal";
import Select from "../../../../components/input/Select";
//hooks
import { useOptionsSelect } from "../../../../hooks/useOptionsSelect";
//services
import { postHomologation } from "../../../../services/Banks/postHomologation";
//utils
import { queryClient } from "../../../../utils/queryClient";

export function HomologationTest({ accId, bank }) {
  const form = useForm();
  const { id } = useParams();
  const errors = form.formState.errors;
  const [showModal, setShowModal] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const { client, isLoadingClients } = useOptionsSelect();

  const onSubmit = async (data) => {
    // console.log("Data: ", data);
    setIsLoading(true);
    const sendData = {
      payer_id: data.user_id,
      current_account_id: accId,
    };

    try {
      const res = await postHomologation(sendData, bank);
      // console.log(res);
      queryClient.setQueryData([`accountData${id}`], (data) => {
        const updatedData = data;
        updatedData.homologation = 1;
        return updatedData;
      });
      toast.success("Teste realizado com sucesso, sua conta está homologada!");
    } catch (error) {

      const response = error?.response?.data;

      let errorMessage = "Erro ao homologar conta! ";

      if (response?.details?.error_description) {
        errorMessage += `: ${response.details.error_description}`;
      } else if (response?.error_description) {
        errorMessage += `: ${response.error_description}`;
      }

      toast.error(errorMessage);
    }
    setIsLoading(false);
  };

  return (
    <>
      <Button
        rounded
        label="Homologar Conta"
        icon="fa-solid fa-copy"
        size="small"
        onClick={() => setShowModal(true)}
      />

      <Modal
        visible={showModal}
        onHide={() => setShowModal(false)}
        dynamicWidth={window.innerWidth <= 992 ? "85vw" : "60vw"}
        dynamicTitle="Teste de Homologação"
      >
        <form className="row" onSubmit={form.handleSubmit(onSubmit)}>
          <div className="col-md-6 mb-3 form-group">
            <Select
              name="user_id"
              control={form.control}
              label={isLoadingClients ? "Carregando..." : "Pagador teste"}
              disabled={isLoadingClients || isLoading}
              options={client}
              errors={errors}
            />
          </div>
          <div className="col-md-4 mt-3 pt-1">
            <Button
              label="Homologar conta"
              icon="fa-solid fa-chevron-right"
              iconPos="right"
              severity="info"
              className="w-100"
              loading={isLoadingClients || isLoading}
            />
          </div>
        </form>
      </Modal>
    </>
  );
}
